//offsets component anchors to compensate for current height of the header and in page navigation
window.offsetInPageNavigationAnchors = function () {
    var inPageNavigationElement = $('.in-page-navigation');
    var headerElement = $('.header');
    var anchorOffset;

    if (inPageNavigationElement.length) {
        anchorOffset = $(inPageNavigationElement).outerHeight();
    }
    else if (headerElement.length) {
        anchorOffset = $(headerElement).outerHeight();
    }

    if (anchorOffset) {
        //unique anchor links
        $('.anchor').css("top", anchorOffset);

        //component based anchor links
        $('.sc-component').css("scroll-margin-top", anchorOffset);

        $('[data-scroll-margin-top]').css("scroll-margin-top", anchorOffset);

        $('[data-sticky]').attr("data-margin-top", anchorOffset);

        //scrollspy offset
        //$('[data-spy]').attr('data-offset', anchorOffset);
    }

    //initialize body scrollspy with post-load calculated offset
    //$('body').scrollspy('dispose');
    //$('body').scrollspy({ target: '#in-page-navigation-scrollspy', offset: anchorOffset ?? 0 });
}

window.hideInvalidPageNavigationLinks = function () {
    var inPageNavigationElement = $('.in-page-navigation');

    if (inPageNavigationElement.length) {
        $(inPageNavigationElement).find('.nav-link').each(function () {
            var targetId = $(this).attr('href');
            var target = $(targetId);
            if (!target.length || !$(target).is(':visible')) {
                console.debug('hideInvalidPageNavigationLinks found, hiding');
                $(this).remove();
            }
        });
    }
}

/* only show in page navigation when not at top of page */
window.bindInPageNavigation = function() {
    var scroll = window.scrollY; 
    var headerElements = $('.header-component');
    var headerElementsOffset = 0;

    //get the total height of all header elements
    $(headerElements).each(function () {
        headerElementsOffset += $(this).outerHeight();
    });

    //offset the calculated height by the height of the in page navigation so that anchor links to the topmost element don't hide the in page nav
    headerElementsOffset = headerElementsOffset - $('.in-page-navigation').outerHeight();

    if (scroll < headerElementsOffset || scroll <= 0) {
        $(".in-page-navigation").fadeOut();
    } else {
        $(".in-page-navigation").fadeIn();
    }
}

$('[data-open-in-page-navigation]').on('click', function () {
    var parent = $(this).closest('.in-page-navigation');
    
    //open menu
    $(parent).find('.in-page-navigation-menu').fadeIn();

    //change icons
    parent.find('.menu-button-open').hide();
    parent.find('.menu-button-close').css('display', 'inline-block');
});

$('[data-close-in-page-navigation]').on('click', function () {
    var parent = $(this).closest('.in-page-navigation');

    //close menu
    $(parent).find('.in-page-navigation-menu').fadeOut();

    //change icons
    parent.find('.menu-button-open').show();
    parent.find('.menu-button-close').css('display', 'none');
});

//image load dependent functions
$(window).on('load', function () {
    offsetInPageNavigationAnchors();

    bindInPageNavigation();
});

$(document).ready(function () {
    hideInvalidPageNavigationLinks();

    $(window).on('resize', throttle(function () {
        offsetInPageNavigationAnchors();
    }, 400));

    //scroll related horizontal nav item into view if neccesary when the element is scrolled to
    //$(window).on('activate.bs.scrollspy', function (e) {
    //    $('#in-page-navigation-scrollspy a.active')[0].scrollIntoView();
    //});

    $(window).on('scroll', throttle(function () {
        bindInPageNavigation();
    }, 400));
});